import {Injectable} from '@angular/core';
import {ObjectValidators} from '@aviary/forms/extensions/form-extensions.types';
import {DateValidators} from '@aviary/forms/fields/date-form-field/date.form-validators';
import {EditHoldValue, PauseAllHoldsValue} from './holds.types';
import {Validators} from '@angular/forms';

@Injectable({providedIn: 'root'})
export class HoldsValidators {
  public readonly editHold: ObjectValidators<EditHoldValue> = {
    pickupBranch: [],
    pauseUntil: [DateValidators.optionalFutureDate],
  };

  public readonly pauseAllHolds: ObjectValidators<PauseAllHoldsValue> = {
    pauseUntil: [Validators.required, DateValidators.futureDate],
  };
}
